import styled from "styled-components"

export const Wrapper = styled.header`
  background: #25252552;
  width: 100%;
  height: 85px;
`
